import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Radio,
  InputGroup,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "react-datepicker/dist/react-datepicker.css";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};
let detail = [], oldTriger, selectedValue;
class SingleStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentTrigger : "OFFER_CLOSING",
      term_percents: '',
      term_days: '',
      detail: '',
      totalPaymentsPercentage: 0,
    };
  }

  handleChange = (e) => {    
    if(e.target.name == 'paymentTrigger'){
      oldTriger = this.state.paymentTrigger;
    }
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({[e.target.name] : e.target.value});
  }
  updateTerm(paymentTrigger){

    let result = 0, totalPer = 0;
    if(detail){
      totalPer = detail.map((data, i) => {
        result = parseInt(result)+parseInt(data.term_percents);
        return result;
      });
    }

    const constData = {
      paymentTrigger: paymentTrigger,
      detail: [{
                "TriggerType" : paymentTrigger,
                "term" : detail,
              }],
      totalPaymentsPercentage: result,
    }
    this.props.saveTermsTriger(constData);
  }
  validate(){
    let status = true;

    if(!this.state.term_percents){
      status = false;
      this.setState({term_percentsError: 'red'})
    }

    if(!this.state.term_days){
      status = false;
      this.setState({term_daysError: 'red'})
    }

    return status;
  }

  handleSave = (e) => {
    e.preventDefault();
    let valid = this.validate();

    if(valid == true){
      detail.push({term_percents: this.state.term_percents, term_days: this.state.term_days});
      let result = 0, totalPer = 0;
      if(detail){
        totalPer = detail.map((data, i) => {
          result = parseInt(result)+parseInt(data.term_percents);
          return result;
        });
      }

      const constData = {
        paymentTrigger: this.state.paymentTrigger,
        detail: [{
                  "TriggerType" : this.state.paymentTrigger,
                  "term" : detail,
                }],
        totalPaymentsPercentage: result,
      }

      this.setState({term_days: '', term_percents: '', totalPaymentsPercentage: result, detail: detail});
      this.props.saveTerms(constData);
    }
  }

  removeTerm = (indexValue) => {
    if(detail.splice(indexValue, 1)){

      let result = 0, totalPer = 0;
        if(detail){
          totalPer = detail.map((data, i) => {
            result = parseInt(result)+parseInt(data.term_percents);
            return result;
          });
      }
      const constData = {
          paymentTrigger: this.state.paymentTrigger,
          detail: [{
                    "TriggerType" : this.state.paymentTrigger,
                    "term" : detail,
                  }],
          totalPaymentsPercentage: result,
      }
      this.setState({totalPaymentsPercentage: result, detail: detail});
      this.props.saveTerms(constData);
    }
  }

  componentDidMount() {}

  componentWillMount() {}

  componentWillReceiveProps(nextProps) {
    if(nextProps.isError){
      this.setState({totalPaymentsPercentageError: 'red'});
    }else{
      this.setState({totalPaymentsPercentageError: ''});
    }

    if(nextProps.termDetail){
      this.setState(nextProps.termDetail);
      detail = nextProps.termDetail.detail;
    }

    if(nextProps.clear){
      this.setState ({
        paymentTrigger : this.state.paymentTrigger,
        term_percents: '',
        term_days: '',
        detail: '',
        totalPaymentsPercentage: 0,
      });
      detail = [];
    }

  }

  componentWillUpdate(nextProps, nextState) {
    if(nextProps.termDetail !== undefined) {
      if(nextProps.termDetail.paymentTrigger !== nextState.paymentTrigger){
        this.updateTerm(nextState.paymentTrigger);
      }
    }
  }

  render() {
    if(this.state.totalPaymentsPercentage == 0){
      detail = [];
    }
    
    return (
      <React.Fragment>
      <Row>
        <Col md={12} xs={12}>
          <ControlLabel>Payment Trigger</ControlLabel><br/> 
          {(this.state.paymentTrigger == 'OFFER_CLOSING') ?
          <Radio name="paymentTrigger" checked= {true} value="OFFER_CLOSING" onClick={this.handleChange} inline>Payment based on offer closing</Radio>
          :
          <Radio name="paymentTrigger" value="OFFER_CLOSING" onClick={this.handleChange} inline>Payment based on offer closing</Radio>
          }
          {(this.state.paymentTrigger == 'TRANSACTION_DATE') ?
          <Radio name="paymentTrigger" checked={true} value="TRANSACTION_DATE" onClick={this.handleChange} inline>Payment based on transaction date</Radio>
          :
          <Radio name="paymentTrigger" value="TRANSACTION_DATE" onClick={this.handleChange} inline>Payment based on transaction date</Radio>
          }
        </Col>
        <Col md={12} xs={12}>
          <ControlLabel>Payment Term</ControlLabel>
        </Col>
      </Row>
      <Row>
        <Col md={1} xs={12}>
        Pay
        </Col>
        <Col md={3} xs={12}>
          <FormGroup controlId="term_percents">
          <FormControl
            type="text"
            value={this.state.term_percents}
            placeholder="Pay Percentage"
            onChange={this.handleChange}
            name="term_percents"
            style={{
              borderColor: this.state
                .term_percentsError
            }}
          />
          </FormGroup>
        </Col>
        <Col md={1} xs={12}>
        %
        </Col>
        <Col md={1} xs={12}>
        after
        </Col>
        <Col md={3} xs={12}>
          <FormGroup controlId="day">
          <FormControl
            type="text"
            value={this.state.term_days}
            placeholder="Day"
            onChange={this.handleChange}
            name="term_days"
            style={{
              borderColor: this.state
                .term_daysError
            }}
          />
          </FormGroup>
        </Col>
        <Col md={2} xs={12}>
        {(this.state.paymentTrigger == 'OFFER_CLOSING') ? 'days' : 'days of transaction date'}
        </Col>
        <Col md={1} xs={12}>
        <Button
          bsStyle="info"
          type="submit"
          id="addButton"
          onClick={this.handleSave}
        >
          Add
        </Button>
        </Col>
      </Row>
      {(!isEmpty(detail)) &&
        <Row>
          {detail.map((data, index) =>
          <Col ley={Math.random()} md={12} xs={12}><b>Payment :</b> Pay {data.term_percents}% within {data.term_days} {(this.state.paymentTrigger == 'OFFER_CLOSING') ? 'days' : 'days of transaction date'}. <a className="text-danger cursor" onClick={this.removeTerm.bind(this, index)}><i className="glyphicon glyphicon-trash"></i></a></Col>
          )}
          <hr/>
        </Row>
      }
      <Row>
        <Col md={4} xs={12}>
          <ControlLabel>Total Percentage :</ControlLabel>
        </Col>
        <Col md={4} xs={12}>
        <FormGroup>
          <InputGroup>
            <FormControl
              type="text"
              value={this.state.totalPaymentsPercentage}
              placeholder="total"
              name="totalPaymentsPercentage"
              style={{
                borderColor: this.state.totalPaymentsPercentageError
              }}
            />
            <InputGroup.Addon>
            %
            </InputGroup.Addon>
          </InputGroup>
        </FormGroup>
        </Col>
      </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps)
)(SingleStep);



// WEBPACK FOOTER //
// ./src/app/views/admin/payoutTerms/SingleStep.js